import * as React from "react";
import { useMemo } from "react";
import styled from "styled-components";
import SearchPageLayoutProvider from "views/components/contexts/SearchPageLayoutProvider";
import { SAVE_COPY } from "views/components/contexts/SearchPageLayoutContext";
import { Row } from "components/bootstrap";
const Container = styled(Row)`
  position: relative;
  flex: 1;
`;
const PageContentLayout = styled.div`
  padding: 0 15px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;
const SearchAreaContainer = React.forwardRef(({ children }, ref) => /* @__PURE__ */ React.createElement(PageContentLayout, { ref }, children));
const NoSidebarSearchLayout = ({ children = void 0, viewActions = SAVE_COPY }) => {
  const searchPageLayout = useMemo(
    () => ({
      sidebar: { isShown: false },
      viewActions,
      searchAreaContainer: { component: SearchAreaContainer }
    }),
    [viewActions]
  );
  return /* @__PURE__ */ React.createElement(SearchPageLayoutProvider, { value: searchPageLayout }, /* @__PURE__ */ React.createElement(Container, null, children));
};
export default NoSidebarSearchLayout;
